import React from 'react';

const DropdownToggle = React.forwardRef(({ style, children, onClick, hrefValue }, ref) => (
  <a
    href={hrefValue}
    ref={ref}
    style={style}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
))

export default DropdownToggle;
